import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { useDispatch, useSelector } from 'react-redux'
import { selectAccountConfig, selectCurrentRoute } from '@selectors'

import { SHOW_ACTION_SHEET, TOGGLE_TAB_BAR } from '@redux/actions/types'

import Icon from '@components/icon/icon.component'
import ScrollUpButton from '@components/scroll-up-button/scroll-up-button.component'

import i18n from 'i18n-js'
import { BUTTON_EMERGENCY, SCREEN_TITLE_TIP, TAB_TITLE_SAFEWALK, TAB_TITLE_MESSAGES, TAB_TITLE_RESOURCES } from '../../assets/i18n/strings'

import useStyles from './header.style'
import { DARK_GRAY_20, GRAY, HOT_PINK, ORANGE_PINK, WHITE } from '@omnilert/components'

const Header = (props) => {
  const classes = useStyles(props)

  const dispatch = useDispatch()
  const Analytics = useSelector(state => state.analytic.analytics)
  const accountConfig = useSelector(selectAccountConfig)

  const currentRoute = useSelector(selectCurrentRoute)

  const pathName = currentRoute?.tab?.path

  const panicButton = accountConfig?.panic_button

  const enablePanicButton = panicButton?.enable_panic_button === '1'

  const showPanicButton = enablePanicButton && currentRoute?.hasPanicButton

  const showHeader = currentRoute?.showHeader

  const [onClickHoldEvent, setOnClickHoldEvent] = useState(null)

  const [clickHeaderStyles, setClickHeaderStyles] = useState({})
  const [clickSVGStyles, setClickSVGStyles] = useState({})

  const titleTranslations = (title) => {
    switch (title) {
    case 'messages':
      return i18n.t(TAB_TITLE_MESSAGES)
    case 'resources':
      return i18n.t(TAB_TITLE_RESOURCES)
    case 'safewalk':
    case 'safewalk/off-campus':
    case 'safewalk/on-campus':
    case 'safewalk/on-hours':
      return i18n.t(TAB_TITLE_SAFEWALK)
    default:
      return i18n.t(SCREEN_TITLE_TIP)
    }
  }

  const handleButtonPress = (e) => {
    e.preventDefault()
    e.stopPropagation()

    setClickHeaderStyles({
      color: WHITE,
      backgroundColor: HOT_PINK,
      transition: 'background-color 1s ease, color 1s ease'
    })

    setClickSVGStyles({
      boxShadow: `0px 4px 4px ${DARK_GRAY_20}`,
      fill: GRAY,
      transition: 'fill 1s ease'
    })

    Analytics.logEvent('PanicButtonTap', { ActiveScreen: pathName })

    setOnClickHoldEvent(
      setTimeout(() => {
        dispatch({
          type: SHOW_ACTION_SHEET,
          payload: 'EMERGENCY'
        })
      }, 500)
    )
  }

  const handleButtonRelease = () => {
    setClickHeaderStyles({
      color: ORANGE_PINK,
      backgroundColor: 'var(--header__emergency-button__background__color)',
      transition: 'background-color 1s ease, color 1s ease'
    })

    setClickSVGStyles({
      transition: 'fill 1s ease'
    })

    setOnClickHoldEvent(clearTimeout(onClickHoldEvent))
  }

  const handleHeaderClick = e => {
    const { detail } = e

    if (detail === 3) {
      dispatch({ type: TOGGLE_TAB_BAR })
    }
  }

  if (!showHeader) return null

  return (
    <div className={classes.headerContainer}>
      <div
        className={classes.headerTitleContainer}
        onClick={handleHeaderClick}
      >
        <span className={classes.headerTitle}>{titleTranslations(currentRoute?.tab?.path)}</span>
      </div>
      {showPanicButton && (
        <div
          className={classes.helpTextContainer}
          data-testid='panic-button'
          onMouseDown={handleButtonPress}
          onMouseLeave={handleButtonRelease}
          onMouseUp={handleButtonRelease}
          onTouchEnd={handleButtonRelease}
          onTouchStart={handleButtonPress}
        >
          <button className={classes.helpButton}>
            <Icon
              style={clickSVGStyles}
              type='emergency-phone'
            />
          </button>
          <div
            className={classes.helpText}
            style={clickHeaderStyles}
          >
            <span>{i18n.t(BUTTON_EMERGENCY)}</span>
          </div>
        </div>
      )}
      {pathName === 'messages' && <ScrollUpButton />}
    </div>
  )
}

Header.defaultProps = {
  title: ''
}

Header.propTypes = {
  title: PropTypes.string
}

export default Header
